const useFormatNumber = () => {
  const formatNumber = (value, nullable = false) => {
    const formatted = Number(value)

    return !isNaN(formatted) ? formatted : nullable ? null : 0
  }
  return { formatNumber }
}

export default useFormatNumber
